module.exports = __webpack_public_path__ + "img/2_159.5f5cbcc0.png";